import { useState, useContext } from "react";
import { Box, Paper, Popper, Stack, Typography,  } from '@mui/material'
import Rates from "./rates";

import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'

export default function TouRatesPopup({ anchorEl, close }: any) {
    const border = custom.border
    const selectedBorderBottom = "2px solid #006ff4";
    const data = useContext(DataContext)
    const [selected, setSelected] = useState('Weekday');

    const handleSelected = (event: any) => {
        setSelected(event.currentTarget.id)
      }

    return (
        <Popper id={"touRates"} open={Boolean(anchorEl)} 
                anchorEl={anchorEl}  >
            <Paper sx={{ 
                        borderRadius: custom.corners4, 
                        width: '350px' }} 
                        elevation={10}>
                <Box px={custom.spacing.sm}
                     pt={custom.spacing.sm}
                    >
                    <Stack alignItems="center" direction="row" >
                        <Typography id="modal-title"  
                            variant="szHeading.Bold.Small" >
                            Your rates
                        </Typography>
                        <Box
                            id="closeRatesPopup"
                            onClick={close}
                            ml="auto"
                            border={border}
                            p={custom.spacing.xxxs}
                            borderRadius={custom.corners3}
                            component="img"
                            src="/images/X.svg" 
                        />
                    </Stack>
                </Box>
                <Box display={"flex"} 
                        justifyContent={"center"} 
                        borderBottom={border}
                        mt={'10px'}>
                    <Typography p={"10px"} id="Weekday"
                        onClick={handleSelected}
                        borderBottom={
                            `${selected==='Weekday' ? 
                                selectedBorderBottom: 'none' }`
                        }
                        color={
                            `${selected==='Weekday' ? 
                                'primary.main': 'inherit' }`
                        }
                        sx={{ cursor: 'pointer',   
                            '&:hover': {
                                backgroundColor: 'sz.colors.hover',
                                boxShadow: 'none',                                              
                            }}}
                        variant="szHeading.Regular.Small">
                        Weekday
                    </Typography>
                    <Typography  p={"10px"} id="Weekend"
                        onClick={handleSelected}
                        borderBottom={
                            `${selected==='Weekend' ? 
                                selectedBorderBottom: 'none' }`
                        }
                        color={
                            `${selected==='Weekend' ? 
                                'primary.main': 'inherit' }`
                        }
                        sx={{ cursor: 'pointer',   
                            '&:hover': {
                                backgroundColor: 'sz.colors.hover',
                                boxShadow: 'none',                                              
                            }}}
                        variant="szHeading.Regular.Small">
                        Weekend
                    </Typography>
                </Box>
                {selected==='Weekday' && 
                    <Rates rates={data?.customer?.provider?.details?.weekdays}/>}
                {selected==='Weekend' && 
                    <Rates rates={data?.customer?.provider?.details?.weekends}/>}
            </Paper>
        </Popper>
    )
}

